import { importMeshCombinations } from '../../actions/sceneActions';

import type { AssetHandler } from '../../assetTypes';
import type { IAssetFile } from '../assetHandler';
import type { DropPayload } from '@/editor/core/dragDropTypes';
import type * as THREE from 'three';

import { store } from '@/app/editor/store';
import { globalStore } from '@/app/globalStore';


/**
 * Handler for scene assets (.genesys-mesh-comb files)
 */
export class MeshCombinationHandler implements AssetHandler {
  async handleSelect(asset: IAssetFile): Promise<void> {
    store.setSelectedAssetItem(asset);
  }

  async handleOpen(asset: IAssetFile): Promise<void> {
    globalStore.showLoadingOverlay('loadMeshCombination');
    await importMeshCombinations(asset.path);
    globalStore.hideLoadingOverlay('loadMeshCombination');
  }

  async handleDragEnter(worldPosition: THREE.Vector3, payload: DropPayload): Promise<void> {
  }

  async handleDragOver(worldPosition: THREE.Vector3, payload: DropPayload): Promise<void> {
  }

  async handleDragCancel(worldPosition: THREE.Vector3, payload: DropPayload): Promise<void> {
  }

  async handleDrop(worldPosition: THREE.Vector3, payload: DropPayload): Promise<void> {
    const asset = payload.payload;
    await this.handleOpen(asset);
  }

  getTargetObject(): unknown {
    return undefined;
  }
}